<template>
  <div class="about-page" role="presentation">
    <header-mobile>
      <h3>{{ $t('message.about') }}</h3>
    </header-mobile>
    <main class="about-wrapper" aria-label="Main content">
      <div class="about-main" role="presentation">
        <p v-if="about_page.text" v-html="$tr(about_page.text)"></p>
        <h2>VisiTOUR&trade;</h2>
        <p>VisiTOUR&trade; {{ $t('about.termSentence1') }}</p>
        <p>{{ $t('about.termSentence2') }}</p>
      </div>
      <div class="about-sub" role="presentation">
        <div class="logo" role="presentation">
          <img src="@/assets/sb-small.png" alt="">&reg;
        </div>
        <p>{{ $t('about.createdPowered') }} <a href="https://www.studentbridge.com/" target="_blank"><b>StudentBridge</b></a></p>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderMobile from '@/components/HeaderMobile'

export default {
  name: 'About',
  components: {
    'header-mobile': HeaderMobile
  },
  computed: {
    ...mapState({
      about_page: state => state.college.settings.about_page
    })
  }
}
</script>
